import { strongPassword } from '@shopee/validators';

export const FORM_CONFIG = [
  {
    name: 'password',
    initial: '',
    validators: [strongPassword('label_account_password_is_weak')],
  },
];
